import { gql } from "@/__generated__/gql";

export const DESTROY_LIVE_EVENT_MUTATION = gql(`
 mutation DestroyLiveEvent(
  $liveEventId: ID!
) {
  destroyLiveEventMutation(input: {
    liveEventId: $liveEventId
  }) {
    success
    errors {
      title
      message
    }
  }
}
`);
